import { useScrollAnimation } from "../../../utils/Utils";
import Odoo_softwaretool from "../../../Assets/odoo_software_tools.png";
import Odoo_Erpsystem from "../../../Assets/Oddo_ErpSystem.png";
import Odoo_customizedservices from "../../../Assets/Oddo_Customization Svices.png";
import Business_process from "../../../Assets/Business_process.png";
import odoo_costeffective from "../../../Assets/Odoo_costeffective.png";
import odoo_productivity from "../../../Assets/odoo_Productivityy.png";
import Image_ContentReusableComponent from "../../component/ReusablaeComponent/Image_ContentReusableComponent";
import HeaderSectionReusableComponent from "../../component/ReusablaeComponent/HeaderSectionReusableComponent";
import OdooLandingPage from "./Odoo/Odoo";
import OdooBenefitsSection from "./Odoo/OdooServices";
import OdooIndustries from "./Odoo/OdooIndustries";
import OdooFaqAccordion from "./Odoo/OddoFAQ";
import ContactForm from "./Odoo/OdooContactUs";
import { useRef } from "react";
const Oddo = () => {
  useScrollAnimation();
   const contact=useRef(null)
  return (
    <div>

      <OdooLandingPage   contact={ contact} />

      <OdooBenefitsSection />

      <OdooIndustries />

      <OdooFaqAccordion />

      <ContactForm ref={contact} />

     
    </div>
  );
};

export default Oddo;
